import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NewsletterPopupService {
  private showPopupSubject = new BehaviorSubject<boolean>(false);
  public showPopup$ = this.showPopupSubject.asObservable();

  constructor() { }

  showPopup() {
    this.showPopupSubject.next(true);
  }

  hidePopup() {
    this.showPopupSubject.next(false);
  }
}